import { render } from "./RequestReviewWarning.vue?vue&type=template&id=63c67308"
import script from "./RequestReviewWarning.vue?vue&type=script&lang=js"
export * from "./RequestReviewWarning.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__